var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompliancePptxFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 210,
    viewBox: "0 0 201 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-3.2%",
    width: "107.2%",
    height: "106.5%",
    filterUnits: "objectBoundingBox",
    id: "w0tt9eur7a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "umomq0mz3b",
    d: "M.196.15h9.09v9.243H.195z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#w0tt9eur7a)",
    fill: "#F0EFEF",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h135.207l51.101 51.101V196a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 38.708,
    height: 38.626,
    rx: 4,
    transform: "translate(80.847 80.07)",
    fill: "#CC492E",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.46 88.7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4t5gx4i7gc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#umomq0mz3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.393h9.089C8.68 4.455 4.828.53 0 .15v9.243z",
    fill: "#FFF",
    mask: "url(#4t5gx4i7gc)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.316 99.698a9.427 9.427 0 1 1-9.427-9.426v9.426h9.427z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.207 5 51.101 51.101h-47.101a4 4 0 0 1-4-4V5z",
    fill: "#DB8B7B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliancePptxFile);
export default __webpack_public_path__ + "static/media/compliance-pptx-file.1e05c3e6.svg";
export { ForwardRef as ReactComponent };